import { Component, OnInit, Input } from '@angular/core';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { faUniversity, faCalendar, faAddressCard, faHome } from '@fortawesome/free-solid-svg-icons';
import { faPhone, faBuilding, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';   

@Component({
    selector: 'app-brand-footer',
    templateUrl: './brand-footer.component.html',
    styleUrls: ['./brand-footer.component.css'],
    standalone: true
})
export class BrandFooterComponent implements OnInit {

  @Input() data: any;

  brandName!: string;
  brandAddress!: string;
  brandCity!: string;
  brandState!: string;
  brandPostalCode!: string;
  brandEmailAddress!: string;
  brandTelephone!: string;
  brandWebSite!: string;

  isBrandAddressVisible: boolean = false;
  isBrandCityStateZipVisible: boolean = false;
  isBrandEmailAddressVisible: boolean = false;
  isBrandTelephoneVisible: boolean = false;
  isBrandWebSiteVisible: boolean = false;

  faAddressCard = faAddressCard;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faHome = faHome;
  faBuilding = faBuilding;
  faEnvelopeOpen = faEnvelopeOpen;
  faPhone = faPhone   

  copyrightYear: number = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
    this.makeBrandFooter(this.data);
  }  

  makeBrandFooter (brandInfo: IBrandInfo) {
    this.brandName = brandInfo.brandName;
    if (brandInfo.brandAddress) {
      this.brandAddress = brandInfo.brandAddress;
      this.isBrandAddressVisible = true;
    }
    if (brandInfo.brandCity || brandInfo.brandState || brandInfo.brandPostalCode) {
      this.brandCity = brandInfo.brandCity || '';
      this.brandState = brandInfo.brandState || '';
      this.brandPostalCode = brandInfo.brandPostalCode || '';
      this.isBrandCityStateZipVisible = true;
    }
    if (brandInfo.brandEmailAddress) {
      this.brandEmailAddress = brandInfo.brandEmailAddress;
      this.isBrandEmailAddressVisible = true;
    }
    if (brandInfo.brandTelephone) {
      this.brandTelephone = brandInfo.brandTelephone;
      this.isBrandTelephoneVisible = true;
    }
    if (brandInfo.brandWebSite) {
      this.brandWebSite = brandInfo.brandWebSite;
      this.isBrandWebSiteVisible = true;
    }
  }  

}
